'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
var FLAT = exports.FLAT = 'FLAT';
var TIERED = exports.TIERED = 'TIERED';


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/self-service-api/static-1.837/js/constants/PricingTypes.js
// module id = 524
// module chunks = 3 4 5